<mat-toolbar color="primary" class="fixed-footer">
  <mat-toolbar-row class="footer-bar" >
    <span class="example-spacer"></span>
    <span>© Copyright 2020 <a class="footer-bar-link" href="http://www.hythesolutions.com" target="_blank">FIINZO.com</a>, Powered by HytheSolutions  Pvt Limited.</span>
  </mat-toolbar-row>
</mat-toolbar>
